import type { JSX } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { BaseFlex } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { ChipItemContainer, TextContainer, ChipItemName, IconCloseContainer } from "./InviteTeammatesChipItem.styled";

interface IInviteTeammatesChipItemProps {
    text: string;
    isError: boolean;
    onClick: () => void;
}

export const InviteTeammatesChipItem = ({ text, isError, onClick }: IInviteTeammatesChipItemProps): JSX.Element => (
    <ChipItemContainer alignItems="center">
        <SWReactIcons
            iconName={isError ? "alert-circle" : "employees"}
            size="sm"
            className="chip-item-icon"
            iconColor={isError ? colorsPalettes.red["s100"] : colorsPalettes.midnight[100]}
        />
        <BaseFlex alignItems="center">
            <TextContainer>
                <ChipItemName>{text}</ChipItemName>
            </TextContainer>
            <IconCloseContainer onClick={onClick}>
                <SWReactIcons
                    iconName="clear-circle"
                    size="sm"
                />
            </IconCloseContainer>
        </BaseFlex>
    </ChipItemContainer>
);
